'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputField = require('../input-field/input-field.vue');

var _inputField2 = _interopRequireDefault(_inputField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        text: '',
        type: '',
        tabIndex: '',
        dataList: [],
        inputVal: '',
        listFilter: { type: Boolean, default: true },
        filterOnObject: { type: String, default: '' },
        loading: { type: Boolean, default: false }
    },
    data: function data() {
        return {
            state: '',
            suggestionList: [],
            selectedItem: 0,
            clicked: false,
            valueTimer: null
        };
    },
    events: {
        'appclick': function appclick(event) {
            var self = this;
            if (!this.$el.contains(event.target)) {
                if (!self.selectedItem) {
                    self.selectItem(0);
                } else {
                    self.selectItem(self.selectedItem);
                }
            }
        },
        inputChanged: function inputChanged() {
            this.selectItem(this.selectedItem);
        }
    },
    watch: {
        'dataList': function dataList() {
            this.filterList();
        }
    },
    components: {
        'input-field': _inputField2.default
    },
    methods: {
        'updateInputVal': function updateInputVal(value) {
            this.inputVal = value;
            if (this.valueTimer) {
                clearTimeout(this.valueTimer);
            }

            var self = this;
            if (value && value.length > 3) {
                this.valueTimer = setTimeout(function () {
                    if (!self.clicked) {
                        self.$dispatch('updateval', value);
                    } else {
                        self.clicked = false;
                    }
                }, 500);
            } else {
                this.clicked = false;
            }
        },
        'filterList': function filterList() {
            var filteredList = [];
            var val = this.inputVal;

            if (this.listFilter) {
                var regex = new RegExp('^' + val, 'gi');

                filteredList = this.objectFilter().filter(function (item) {
                    var match = item.match(regex);
                    if (match) {
                        return item.match(regex).length > 0;
                    }
                });
            } else {
                filteredList = this.objectFilter();
            }

            this.selectedItem = 0;
            this.state = filteredList && filteredList.length > 0 && val && val.length > 0 ? 'open' : '';
            this.suggestionList = filteredList;
        },
        'moveDown': function moveDown(event) {
            event.preventDefault();
            if (this.suggestionList.length - 1 > this.selectedItem && this.state == 'open') {
                this.selectedItem += 1;
            }
        },
        'moveUp': function moveUp(event) {
            event.preventDefault();
            if (this.selectedItem > 0 && this.state == 'open') {
                this.selectedItem -= 1;
            }
        },
        'disableUpDown': function disableUpDown(event) {
            if (event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 13) {
                event.preventDefault();
            }
        },
        'clickItem': function clickItem(index) {
            this.selectItem(index);
        },
        'selectItem': function selectItem(index) {
            this.state = '';
            this.selectedItem = index;
            this.inputVal = this.suggestionList[index];
            this.clicked = true;
            if (typeof this.dataList[index] !== 'undefined') {
                this.$dispatch('selectitem', this.dataList[index]);
            }
        },
        'keyEvent': function keyEvent(event) {
            switch (event.keyCode) {
                case 38:
                    //Up arrow
                    this.moveUp(event);
                    break;
                case 40:
                    //Down arrow
                    this.moveDown(event);
                    break;
                case 13:
                    //Enter
                    if (this.state.length > 0) {
                        this.selectItem(this.selectedItem);
                    }
                    break;
            }
        },
        objectFilter: function objectFilter() {
            var fob = this.filterOnObject;
            if (fob.length > 0) {
                return this.dataList.map(function (a) {
                    return a[fob];
                });
            } else {
                return this.dataList;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<div class=\"suggestion-list-component input-field {{ state }}\"><input-field v-on:keyup=keyEvent :inpvalue=inputVal v-on:keydown=disableUpDown :type=type :text=text v-on:update=updateInputVal :tab-index=tabIndex :loading=loading></input-field><slot name=button></slot><ul class=suggestion-list><li v-for=\"(index, item) in suggestionList\" track-by=$index class=suggestion-list__item v-bind:class=\"{'selected': (index == this.selectedItem)}\" @click=clickItem(index)>{{ item }}</ul></div>"
